import Mixpanel from 'mixpanel-browser';
import { isCathayMr, analyticsToken } from 'config';
import { deviceType, IN_APP_WEBVIEW } from 'utils/device-util';

class MixpanelService {
  constructor() {
    if (isCathayMr && deviceType() === IN_APP_WEBVIEW) {
      Mixpanel.init(analyticsToken);
    }
  }

  setIdentify = trackId => {
    if (isCathayMr && deviceType() === IN_APP_WEBVIEW) {
      Mixpanel.identify(trackId);
    }
  };

  track = (name, properties, callback) => {
    if (isCathayMr && deviceType() === IN_APP_WEBVIEW) {
      Mixpanel.track(name, properties, callback);
    }
  };

  profile = properties => {
    if (isCathayMr && deviceType() === IN_APP_WEBVIEW) {
      Mixpanel.people.set(properties);
    }
  };
}

export default new MixpanelService();
